/**
 * Normalise a string for tolerant, human-friendly searching.
 *
 * Place-of-safety and hospital names are full of punctuation and casing that
 * users rarely reproduce exactly when typing (e.g. "Queen's" vs "Queens",
 * "St. Mary's" vs "St Marys"). Matching on the raw string makes these names
 * effectively undiscoverable, which pushes users towards manual free-text
 * entry. Folding both the query and the candidate through this function before
 * comparing removes that cliff.
 *
 * The transformation:
 * - decomposes accented characters and strips the diacritics (café -> cafe)
 * - lowercases
 * - drops apostrophes entirely so "Queen's" collapses onto "Queens"
 * - replaces every remaining run of non-alphanumeric characters (punctuation
 *   and whitespace alike) with a single space, then trims the ends
 *
 * Note: `.normalize` is the standard JavaScript String API and must keep its
 * US spelling; the exported helper itself uses UK spelling ("normalise").
 */
export const normaliseForSearch = (value) => value
    .normalize("NFKD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .replace(/['’`]/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
//# sourceMappingURL=normaliseForSearch.js.map